(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(64796);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66383);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55464);
/* harmony import */ var next_urql__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38002);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26806);
/* harmony import */ var _components_content_page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79803);
/* harmony import */ var _features_locations_finder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17187);
/* harmony import */ var _services_content_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44973);
/* harmony import */ var _types_graphql_schema__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91021);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32210);










/*
 * Some brands use commerce+ and some do not, so our entry route
 * shows either the locations finder or the brand's configured homepage
 */ function Index(param) {
    var serverState = param.serverState;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,urql__WEBPACK_IMPORTED_MODULE_7__/* .useQuery */ .aM)({
        query: _types_graphql_schema__WEBPACK_IMPORTED_MODULE_4__/* .HomePageQueryDocument */ .vt
    }), 1), data = ref6[0].data;
    if (!Boolean(data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.length)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .Hydrate */ .p, {
            state: serverState,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_locations_finder__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        });
    }
    var _id, _seoTitle, _seoDescription, _seoImage;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__/* .Hydrate */ .p, {
        state: serverState,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_content_page__WEBPACK_IMPORTED_MODULE_1__/* .Page */ .T, {
            id: (_id = data === null || data === void 0 ? void 0 : (ref1 = data.pages) === null || ref1 === void 0 ? void 0 : ref1[0].id) !== null && _id !== void 0 ? _id : "",
            seoTitle: (_seoTitle = data === null || data === void 0 ? void 0 : (ref2 = data.pages) === null || ref2 === void 0 ? void 0 : ref2[0].seoTitle) !== null && _seoTitle !== void 0 ? _seoTitle : "",
            seoDescription: (_seoDescription = data === null || data === void 0 ? void 0 : (ref3 = data.pages) === null || ref3 === void 0 ? void 0 : ref3[0].seoDescription) !== null && _seoDescription !== void 0 ? _seoDescription : "",
            seoImage: (_seoImage = data === null || data === void 0 ? void 0 : (ref4 = data.pages) === null || ref4 === void 0 ? void 0 : ref4[0].seoImage) !== null && _seoImage !== void 0 ? _seoImage : "",
            content: data === null || data === void 0 ? void 0 : (ref5 = data.pages) === null || ref5 === void 0 ? void 0 : ref5[0].content
        })
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,next_urql__WEBPACK_IMPORTED_MODULE_9__/* .withUrqlClient */ .X)(function(ssrExchange, ctx) {
    var ref;
    var meta = undefined;
    if (true) {
        meta = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .getRequestOrigin */ .vi)(window.location.host);
    } else {}
    return (0,_services_content_service__WEBPACK_IMPORTED_MODULE_3__/* .contentSetupAPIRequests */ .XG)(ssrExchange, meta);
}, {
    neverSuspend: true
})(Index));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [513,372,295,593,974,631,588,356,594,212,187,774,888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);